import { Parse } from 'parse';

/// проверка на беке - можно ли платить и перейти на экран оплаты
export const goPay = async (navigation, route) => {
  try {
    const config = await Parse.Config.get();
    const canPay = config.get('canPay');
    console.log('goPay:', canPay);
    canPay &&
      navigation.navigate('DonateScreen', {
        redirectRoute: route,
      });
  } catch (e) {
    //TODO сделать обработку
    console.log('ошибка Parse servera: ', e.message);
  }
};
